import { render } from "./download.vue?vue&type=template&id=64764fbf&scoped=true"
import script from "./download.vue?vue&type=script&lang=js"
export * from "./download.vue?vue&type=script&lang=js"

import "./download.vue?vue&type=style&index=0&id=64764fbf&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64764fbf"]])

export default __exports__